'use client'

import { Moon, Sun } from 'lucide-react'
import { useRouter } from 'next/navigation'
import { useTransition } from 'react'

import { FRAME_SETTINGS_ROUTES, postFrameSetting } from './settings'
import type { FrameTheme } from './types'

/**
 * Light or dark, for this device. `current` is the cookie's value; without one
 * the stylesheet follows the system, and the first click then pins a theme.
 */
export function ThemeToggle({
  current,
  labels
}: {
  current: FrameTheme | null
  labels: { toggle: string; light: string; dark: string }
}) {
  const router = useRouter()
  const [pending, startTransition] = useTransition()
  const dark = current === 'dark'

  return (
    <button
      type="button"
      aria-label={labels.toggle}
      title={dark ? labels.light : labels.dark}
      disabled={pending}
      onClick={() =>
        startTransition(async () => {
          if (await postFrameSetting(FRAME_SETTINGS_ROUTES.theme, dark ? 'light' : 'dark')) router.refresh()
        })
      }
      className="av-iconbtn av-iconbtn--md av-iconbtn--secondary disabled:opacity-50"
    >
      {dark ? <Sun className="size-4" /> : <Moon className="size-4" />}
    </button>
  )
}
